import { useState } from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const CEREMONIES = {
  light: {
    img: "/img/lights.jpg",
    title: "Come Into the Light",
    name: "The Light Ceremony",
    date: "November 22nd – 27th",
    body: [
      "The Light Ceremony is a gathering of illumination and renewal, a sacred moment to release what has dimmed your spirit and call your fire back home.",
      "Seats are held with intention. Reserve yours below.",
    ],
    button: "Hold My Place in the Light",
  },
  waterfall: {
    img: "/img/waterfall.jpg",
    title: "Waterfall Medicine",
    name: "Waterfall Medicine: Field Trip",
    date: "October 30th, 2026 (Tentative)",
    body: [
      "A day of healing, gratitude & big love. Honor the waters. Release and receive. Heal, give thanks, and step into blessings.",
      "Come as you are. Leave more blessed.",
    ],
    button: "Hold My Place at the Waters",
  },
};

export default function CeremonyRSVP() {
  const { ceremony } = useParams();
  const { user } = useAuth();
  const c = CEREMONIES[ceremony];
  const [form, setForm] = useState({ name: user?.name || "", phone: user?.phone || "", email: user?.email || "", guests: 0 });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState("");
  if (!c) return <Navigate to="/members/ceremonies" replace />;
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/rsvp", { ...form, guests: Number(form.guests), ceremony });
      setDone(data.message);
    } catch (err) {
      setError(formatErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid={`rsvp-page-${ceremony}`} className="grid lg:grid-cols-2 gap-12 items-start">
      <img src={c.img} alt={c.name} className="rounded-3xl w-full shadow-[0_40px_80px_-40px_rgba(35,43,27,.6)]" />
      <div>
        <span className="eyebrow">{c.name} · {c.date}</span>
        <h1 data-testid="rsvp-title" className="font-serif-h font-light text-4xl sm:text-5xl text-[#577731] mt-4">{c.title}</h1>
        {c.body.map((p) => <p key={p} className="mt-6 text-lg leading-relaxed text-[#232b1b]/80">{p}</p>)}
        {done ? (
          <div data-testid="rsvp-success" className="mt-10 rounded-3xl bg-[#b1cc90]/35 p-10">
            <p className="font-serif-h text-3xl text-[#577731]">{done}</p>
            <p className="mt-3 text-sm text-[#232b1b]/75">Your RSVP has been received by the circle. Carry this light with you until we gather.</p>
            <Link to="/members/ceremonies" data-testid="rsvp-back-btn" className="btn btn-ghost mt-8">Back to Ceremonies</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 space-y-5" data-testid="rsvp-form">
            <div><label className="label">Name</label><input required className="field" value={form.name} onChange={set("name")} data-testid="rsvp-name-input" /></div>
            <div className="grid sm:grid-cols-2 gap-5">
              <div><label className="label">Phone</label><input required className="field" value={form.phone} onChange={set("phone")} data-testid="rsvp-phone-input" /></div>
              <div><label className="label">Email</label><input required type="email" className="field" value={form.email} onChange={set("email")} data-testid="rsvp-email-input" /></div>
            </div>
            <div><label className="label">Number of guests</label><input required type="number" min={0} max={20} className="field max-w-[10rem]" value={form.guests} onChange={set("guests")} data-testid="rsvp-guests-input" /></div>
            {error && <p data-testid="rsvp-error" className="text-sm text-[#9c3d5c]">{error}</p>}
            <button disabled={busy} data-testid="rsvp-submit-btn" className="btn btn-mauve">{busy ? "Holding your seat…" : c.button}</button>
          </form>
        )}
      </div>
    </div>
  );
}
